import { Suspense, useEffect } from 'react';
import PropTypes from 'prop-types';
import Loader from './Loader';

// Reset only on a full browser load, never during client-side navigation.
let hasRenderedPage = false;

function PageReady({ children }) {
  useEffect(() => {
    hasRenderedPage = true;
  }, []);
  return children;
}
PageReady.propTypes = { children: PropTypes.node };

function RouteLoading() {
  return <Loader fullScreen={!hasRenderedPage} />;
}

const Loadable = (Component) => {
  function LoadablePage(props) {
    return (
      <Suspense fallback={<RouteLoading />}>
        <PageReady><Component {...props} /></PageReady>
      </Suspense>
    );
  }
  return LoadablePage;
};

export default Loadable;
